import { render, staticRenderFns } from "./ArenaPointTypeList.vue?vue&type=template&id=9ab3087e"
import script from "./ArenaPointTypeList.vue?vue&type=script&lang=js"
export * from "./ArenaPointTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports